import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { STORE_ADVERT, AdvertSlot } from '../../constants';
import { AdvertStore } from '../../stores';
import { Advert } from '../../components/Advert';
import './style.css';

export interface SiteBannerProps {
  /* [STORE_ADVERT]: AdvertStore; */
}

export interface SiteBannerState {
  /* empty */
}

@inject(STORE_ADVERT)
@observer
export class SiteBanner extends React.Component<
  SiteBannerProps,
  SiteBannerState
> {
  async componentDidMount() {
    const advertStore = this.props[STORE_ADVERT] as AdvertStore;

    await advertStore.fetchAdvertsForSlot(AdvertSlot.SiteBanner);
  }

  render() {
    const advertStore = this.props[STORE_ADVERT] as AdvertStore;

    return (
      <div className="site-banner-wrapper">
        <Advert
          className="site-banner"
          adverts={advertStore.adverts[AdvertSlot.SiteBanner]}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/SiteBanner/index.tsx